<template>
  <div class="tradesman-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.sorce"
                  clearable
                  filterable
                  placeholder="选择匠人来源">
            <Option v-for="item in sorceList"
                    :value="item.id"
                    :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入客服电话/店铺名称/匠人姓名"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.phone"
                 clearable
                 placeholder="输入手机号"></Input>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      :value="[formItem.starttime, formItem.endtime]"
                      @on-change="changeDate"
                      style="width: 350px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem class="f-r"
                  v-if="this.register_status == 1">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportShouru()">导出匠人收入记录</Button>
        </FormItem>
        <FormItem class="f-r"
                  v-if="this.register_status == 1">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportShouchu()">导出匠人售出统计</Button>
        </FormItem>
        <FormItem class="f-r"
                  v-if="this.register_status == 1">
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportTrad()">导出有订单的匠人</Button>
        </FormItem>
        <FormItem class="f-r"
                  v-if="this.register_status == 0">
          <Button type="success"
                  :loading="exportLoading"
                  @click="showCreate()">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 三方店铺列表弹出 -->
    <Drawer title="三方店铺"
            v-model="showModalSan"
            width="800"
            :mask-closable="false"
            :styles="styles">
      <div style="marginBottom:20px">
        <Button type="success"
                @click="showadd">添加三方店铺</Button>
      </div>
      <Table border
             :columns="sfColumns"
             :data="sfList"
             :loading="sanloading"></Table>
    </Drawer>
    <!-- 添加/编辑弹出 -->
    <Drawer :title="sanTitle"
            v-model="showModaladd"
            width="500"
            :mask-closable="false"
            :styles="styles">
      <div style="display:flex;height:65px">
        <div style="marginRight:10px;width:40px">标题</div>
        <div>
          <Input v-model="sanps.title"
                 placeholder="标题"></Input>
        </div>
      </div>
      <div style="display:flex;height:200px">
        <div style="marginRight:10px;width:40px">图片</div>
        <div>
          <div style="marginBottom:20px">
            <RadioGroup v-model="picType"
                        @on-change="changePictype">
              <Radio label="1">从三方图库选择</Radio>
              <Radio label="2">重新上传</Radio>
            </RadioGroup>
          </div>

          <div v-if="picType == 1">
            <Button style="marginBottom:15px"
                    type="success"
                    @click="showsanList = true;valuePic=''">从三方店铺选择</Button>
            <div v-if="picact && picact != ''"
                 style="display:flex;align-items: center;">
              <img style="width:100px;marginRight:15px"
                   :src="$publicData.ossUrl + picact" />
              <Icon type="md-close"
                    size="25"
                    @click="picact = ''" />
            </div>
          </div>
          <div v-else>
            <upload-thumb v-model="sanps.thumb"
                          ref="uploadthumb"
                          :defaultList="thumblistsan"
                          :autoCropWidth="300"
                          :autoCropHeight="300"
                          :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:300*300'"></upload-thumb>
          </div>
        </div>
      </div>
      <div style="display:flex">
        <div style="marginRight:10px;width:40px;lineHeight:32px">链接</div>
        <!-- <Input v-model="sanps.url" placeholder="请输入链接"></Input> -->
        <div style="flex:1">
          <div style="marginBottom:20px">
            <RadioGroup v-model="addType"
                        @on-change="changeaddtype">
              <Radio label="1">外部地址</Radio>
              <Radio label="2">文本复制</Radio>
            </RadioGroup>
          </div>

          <div v-if="addType == 1">
            <Input v-model="sanps.url"
                   placeholder="http://"></Input>
          </div>
          <div v-else>
            <Input v-model="sanps.texturl"
                   placeholder="请输入文本地址"></Input>
          </div>
        </div>
      </div>
      <div style="marginTop:50px">
        <Button style="margin-right: 8px"
                @click="showModaladd = false">取消</Button>
        <Button type="primary"
                @click="addsan">提交</Button>
      </div>
    </Drawer>
    <Modal v-model="showsanList"
           title="三方图片库"
           width="600"
           @on-ok="actsanPic"
           @on-cancel="qusanPic">
      <div class="sanRables">
        <RadioGroup v-model="valuePic"
                    @on-change="changePicact">
          <Radio :label="item.thumb"
                 v-for="(item, index) in sanlist"
                 :key="index"><img :src="$publicData.ossUrl + item.thumb" /></Radio>
        </RadioGroup>
      </div>
    </Modal>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="tradesman"
            :label-width="60"
            ref="tradesmanValidate"
            :rules="tradesmanValidate">
        <Row>
          <Col span="6">
          <FormItem label="选择匠人来源"
                    label-position="top"
                    style="padding-left:20px">
            <Select v-model="tradesman.sorce"
                    clearable
                    filterable
                    placeholder="选择匠人来源">
              <Option v-for="item in sorceList"
                      :value="item.id"
                      :key="item.id">{{ item.title }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="选择匠人分类"
                    label-position="top">
            <Select v-model="tradesman.cate_id"
                    clearable
                    placeholder="选择匠人分类">
              <Option v-for="item in cateList"
                      :value="item.id"
                      :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="选择技艺"
                    label-position="top"
                    style="padding-left:20px">
            <Select v-model="tradesman.skill"
                    clearable
                    placeholder="选择技艺">
              <Option v-for="item in skillList"
                      :value="item.id"
                      :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="选择匠人类型"
                    label-position="top"
                    style="padding-left:20px">
            <Select v-model="tradesman.type"
                    clearable
                    filterable
                    placeholder="选择匠人类型">
              <Option :value="1"
                      :key="1">企业认证</Option>
              <Option :value="2"
                      :key="2">个人认证</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="匠人等级"
                    label-position="top">
            <Input v-model="tradesman.auth_company"
                   placeholder="请输入匠人等级"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="8">
          <FormItem label="省-市-县"
                    label-position="top">
            <Select v-model="tradesman.area1"
                    placeholder="省"
                    @on-change="shengChange">
              <Option v-for="item in shengList"
                      :value="item.id"
                      :key="item.id">{{ item.areaname }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="tradesman.area2"
                    placeholder="市"
                    @on-change="shiChange">
              <Option v-for="item in shiList"
                      :value="item.id"
                      :key="item.id">{{ item.areaname }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="tradesman.area3"
                    placeholder="县">
              <Option v-for="item in quList"
                      :value="item.id"
                      :key="item.id">{{ item.areaname }}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="店铺名称"
                    label-position="top"
                    prop="nickname">
            <Input v-model="tradesman.nickname"
                   placeholder="请输入店铺名称"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="关键字"
                    label-position="top"
                    prop="keyword"
                    style="padding-left:20px">
            <Input v-model="tradesman.keyword"
                   placeholder="输入关键字,多个用','分隔"></Input>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="店铺简介"
                  prop="describe">
          <Input v-model="tradesman.describe"
                 type="textarea"
                 :rows="4"
                 placeholder="店铺简介..."></Input>
        </FormItem>
        <FormItem label="店铺详细介绍"
                  prop="introduce">
          <UEditor v-model="tradesman.introduce"
                   ref="editContent"></UEditor>
        </FormItem>
        <Row v-if="register_status == 1">
          <Col span="8">
          <FormItem label="身份证正面照"
                    prop="legal_photo_facade">
            <upload-thumb v-model="tradesman.legal_photo_facade"
                          :ref="thumbRefList[0]"
                          :defaultList="thumblist[0]"
                          :autoCropWidth="118"
                          :autoCropHeight="74"
                          :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74'"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="身份证反面照"
                    prop="legal_photo_back">
            <upload-thumb v-model="tradesman.legal_photo_back"
                          :ref="thumbRefList[1]"
                          :defaultList="thumblist[1]"
                          :autoCropWidth="118"
                          :autoCropHeight="74"
                          :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:118*74'"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="营业执照照片"
                    prop="company_photo">
            <upload-thumb v-model="tradesman.company_photo"
                          :ref="thumbRefList[5]"
                          :defaultList="thumblist[5]"
                          :autoCropWidth="750"
                          :autoCropHeight="750"
                          :defaultTip="
                  '图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750'
                "></upload-thumb>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="6">
          <FormItem label="匠人头像"
                    prop="thumb">
            <upload-thumb v-model="tradesman.thumb"
                          :ref="thumbRefList[2]"
                          :defaultList="thumblist[2]"
                          :autoCropWidth="100"
                          :autoCropHeight="100"
                          :defaultTip="
                  '图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100'
                "></upload-thumb>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="形象图片"
                    prop="image">
            <upload-thumb v-model="tradesman.image"
                          :ref="thumbRefList[3]"
                          :defaultList="thumblist[3]"
                          :autoCropWidth="690"
                          :autoCropHeight="500"
                          :defaultTip="
                  '图片格式:jpg、jpeg、png、gif,建议图片尺寸:690*500'
                "></upload-thumb>
          </FormItem>
          </Col>
          <Col span="6"
               v-if="register_status == 1">
          <FormItem label="资质证明">
            <upload-thumb v-model="tradesman.zizhi_picture"
                          :ref="thumbRefList[4]"
                          :defaultList="thumblist[4]"
                          :autoCropWidth="750"
                          :autoCropHeight="750"
                          :defaultTip="
                  '图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750'
                "></upload-thumb>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="姓名"
                    label-position="top">
            <Input v-model="tradesman.legal_person"></Input>
          </FormItem>
          </Col>
          <Col span="12"
               v-if="register_status == 1">
          <FormItem label="执照号码"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="tradesman.company_code"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="客服电话"
                    label-position="top">
            <Input v-model="tradesman.phone"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="地址"
                    label-position="top"
                    style="padding-left:20px">
            <Input v-model="tradesman.address"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <!-- <Col span="6"
               v-if="register_status==1">
          <FormItem label="是否开发票"
                    label-position="top">
            <RadioGroup v-model="tradesman.is_invoice">
              <Radio :label="0"
                     :true-value="0">否</Radio>
              <Radio :label="1"
                     :true-value="1">是</Radio>
            </RadioGroup>
          </FormItem>
          </Col>-->
          <Col span="6">
          <FormItem label="是否推荐"
                    label-position="top">
            <RadioGroup v-model="tradesman.is_pos">
              <Radio :label="0"
                     :true-value="0">否</Radio>
              <Radio :label="1"
                     :true-value="1">是</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="6">
          <FormItem label="审核状态"
                    label-position="top">
            <Select v-model="tradesman.status"
                    clearable
                    filterable
                    placeholder="审核状态">
              <Option :value="0"
                      :key="0">待审核</Option>
              <Option :value="1"
                      :key="1">通过审核</Option>
              <Option :value="2"
                      :key="2">未通过审核</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="排序"
                    label-position="top">
            <Input v-model="tradesman.sort"></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="状态"
                    label-position="top"
                    v-if="tradesman.del_flag">
            <Tag color="green"
                 v-if="tradesman.del_flag == 0">正常</Tag>
            <Tag color="red"
                 v-if="tradesman.del_flag == 1">禁用</Tag>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods('tradesmanValidate')">提交</Button>
      </div>
    </Drawer>
    <!--角色管理-->
    <Modal v-model="showRoleStatus"
           title
           @on-ok="createRole('roleInfoValidate')"
           :loading="loading">
      <Form :model="roleInfo"
            ref="roleInfoValidate"
            :rules="roleInfoValidate"
            action="javascript:void(0)">
        <FormItem label="角色">
          <CheckboxGroup v-model="roleInfo.role_ids"
                         @on-change="roleCheck">
            <Checkbox v-for="item in roleList"
                      :key="item.id"
                      :label="item.id">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "tradesman-list",
  data () {
    return {
      // 三方店铺
      sanTitle: "添加三方店铺",
      valuePic: "",//单选选中
      picact: "", //三方图片库选中
      showsanList: false, //三方图片库弹出
      sfColumns: [
        {
          title: "Id",
          key: "id",
          width: "100px",
        },
        {
          title: "标题",
          key: "title",
          width: "100px",
        },
        {
          title: "图片",
          key: "thumb",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large",
                    click: "",
                  },
                  nativeOn: {
                    click: () => {
                      this.visible = true;
                      this.imgUrl = this.$publicData.ossUrl + params.row.thumb;
                      this.viewerImages = [
                        this.$publicData.ossUrl + params.row.thumb,
                      ];
                      this.$viewer.show();
                    },
                  },
                },
                ""
              ),
            ]);
          },
        },
        {
          title: "链接",
          key: "url",
          width: "300px",
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.showedit(params.row.id);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.removesf(params.row.id);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      sfList: [],
      sanloading: false,
      thumblistsan: [],
      sanps: {
        id: "",
        thumb: "",
        url: "", //链接
        texturl: "",
        uuid: "",
      },
      sanlist: [], //三方店铺图片列表
      picType: "1", //图片选择方式
      addType: "1", //地址填写方式
      showModaladd: false, //添加编辑三方店铺弹出
      showModalSan: false, //三方店铺列表弹出
      // 抽屉参数
      value3: false,
      isable: false,
      showRoleStatus: false,
      exportLoading: false,
      shengList: [],
      shiList: [],
      quList: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static",
      },
      tradesman: {
        type: "0",
        is_invoice: "0",
        status: "1",
        auth_status: "0",
        sort: "0",
        is_pos: "0",
        keyword: "",
      },
      isClear: false,
      loading: true,
      dataloading: false,
      thumbRefList: ["zero", "one", "two", "three", "four", "five", "six"],
      thumblist: [[], [], [], [], [], [], []],
      thumblistTwo: [],
      cates: [],
      cateList: [],
      skillList: [],
      intangibleList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
      },
      formItem: {
        key: "",
        phone: "",
      },
      list: [
        {
          title: "排序",
          key: "sort",
          fixed: "left",
          width: 90,
        },
        {
          title: "Id",
          key: "id",
          width: 90,
        },
        {
          title: "匠人分类",
          key: "catename",
          width: 150,
        },
        {
          title: "店铺名称",
          key: "nickname",
          width: 150,
        },
        {
          title: "匠人等级",
          key: "auth_company",
          width: 150,
        },
        {
          title: "手机号",
          key: "username",
          width: 150,
        },
        {
          title: "客服电话",
          key: "phone",
          width: 150,
        },
        {
          title: "账户余额",
          key: "tradmoney",
          width: 150,
        },
        {
          title: "海报",
          key: "registe_at",
          minWidth: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "a",
                {
                  attrs: {
                    href: this.$publicData.ossUrl + params.row.path_new,
                    target: "_blank",
                  },
                  style: {
                    color: "#3c763d",
                  },
                },
                this.$publicData.ossUrl + params.row.path_new
              ),
            ]);
          },
        },
        {
          title: "操作",
          key: "action",
          width: 400,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      params.row.qrcode_num == 0 ? "none" : "inline - block",
                  },
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.getqrcodes(params.row.uuid);
                    },
                  },
                },
                "二维码"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.goodlist(params.row.uuid);
                    },
                  },
                },
                "商品列表"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.roleDetail(params.row.id);
                    },
                  },
                },
                "角色"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.sanDetail(params.row.uuid);
                    },
                  },
                },
                "三方店铺"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                  },
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    // marginRight:'8px'
                  },
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.uuid, params.row.id);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tablelist: [],
      sorceList: [],
      showModalStatus: false,
      tradesmanValidate: {},
      roleInfo: {
        role_ids: [],
      },
      roleInfoValidate: {},
      roleList: [],
      id: 0,
      role_ids: [],
      register_status: 1,
    };
  },
  created: function () {
    this.register_status = this.$route.params.register_status;
    this.getTableList();
    this.getCateList();
    this.getSkillList();
    this.getShengList();
    this.getSorceList();
    // 三方店铺数据
    this.getSanList();
    this.$api.merchantRole.list({ size: 10000 }).then((res) => {
      this.roleList = res.result.list;
    });
  },
  watch: {
    $route: function (val) {
      this.register_status = this.$route.params.register_status;
      this.pages.page = 1;
      this.getTableList();
    },
  },
  components: {
    UploadThumb,
    UEditor,
    uploadthumbTwo,
  },

  methods: {
    removesf (id) {
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tradesmanshopthumb.remove({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getSfList(this.sanps.uuid);
            }
          });
        },
      });
    },
    actsanPic () {
      console.log("picact", this.picact);
      this.picact = this.valuePic;
    },
    qusanPic () {
      console.log("picact", this.picact);
      // this.picact = "";
    },
    // 三方图片库切换
    changePicact (e) {
      console.log("e", e, this.picact);
    },
    // 三方店铺数据列表
    getSanList () {
      this.$api.defaultshopthumb.list({ page: 1, size: 999 }).then((res) => {
        if (res.code == 200) {
          this.sanlist = res.result.list;
        }
      });
    },
    getSfList (id) {
      this.$api.tradesmanshopthumb
        .list({ uuid: id, page: 1, size: 999 })
        .then((res) => {
          if (res.code == 200) {
            this.sfList = res.result.list;
          }
        });
    },
    // 点击添加三方店铺提交
    addsan () {
      if (this.picType == 1) {
        this.sanps.thumb = this.picact;
      } else {
        if (this.$refs["uploadthumb"].uploadList.length > 0) {
          this.sanps.thumb = this.$refs["uploadthumb"].uploadList[0].url;
        } else {
          this.sanps.thumb = null;
        }
      }
      if (this.sanps.thumb == "" || !this.sanps.thumb) {
        this.$Message.error("请选择图片");
        return;
      }
      //   if (this.sanps.url == "" || !this.sanps.url) {
      //     this.$Message.error("请输入链接");
      //     return;
      //   }
      if (this.sanTitle == "添加三方店铺") {
        this.sanps.id = null;
        this.$api.tradesmanshopthumb.create(this.sanps).then((res) => {
          if (res.code == 200) {
            this.showModaladd = false;
            this.$Message.success(res.msg);
            this.getSfList(this.sanps.uuid);
          }
        });
      } else {
        this.$api.tradesmanshopthumb.edit(this.sanps).then((res) => {
          if (res.code == 200) {
            this.showModaladd = false;
            this.$Message.success(res.msg);
            this.getSfList(this.sanps.uuid);
          }
        });
      }
    },
    // 切换上传图片类型
    changePictype (e) {
      console.log("e", e, this.picType);
      this.picact = "";
      this.thumblistsan = [];
      this.sanps.thumb = "";
    },
    // 切换地址填写类型
    changeaddtype (e) {
      console.log("e", e, this.addType);
      this.sanps.url = "";
      this.sanps.texturl = "";
    },
    // 点击添加三方店铺按钮
    showadd () {
      this.sanTitle = "添加三方店铺";
      this.showModaladd = true;
      this.sanps.thumb = "";
      this.sanps.url = "";
      this.sanps.texturl = "";
      this.thumblistsan = [];
      this.picact = "";
      this.picType = "1";
      this.addType = "1";
    },
    showedit (id) {
      this.sanps.id = id;
      this.sanTitle = "编辑三方店铺";
      this.showModaladd = true;
      this.sanps.thumb = "";
      this.sanps.url = "";
      this.sanps.texturl = "";
      this.thumblistsan = [];
      this.$api.tradesmanshopthumb.detail({ id: id }).then((res) => {
        if (res.code == 200) {
          this.sanps.url = res.result.url;
          this.sanps.title = res.result.title;
          this.sanps.texturl = res.result.texturl;
          this.picact = res.result.thumb;
          if (this.sanps.texturl && this.sanps.texturl != "") {
            this.addType = "2";
          }
          //   this.sanps.thumb = res.result.thumb;
          //   this.thumblistsan.push({
          //     name: res.result.thumb,
          //     url: res.result.thumb,
          //     status: "finished",
          //   });
        }
      });
    },
    // 点击三方店铺
    sanDetail (id) {
      this.sanps.uuid = id;
      this.showModalSan = true;
      this.getSfList(id);
    },
    getTableList: function () {
      this.dataloading = true;
      this.$api.tradesman
        .list({
          page: this.pages.page,
          size: this.pages.size,
          register_status: this.register_status,
        })
        .then((res) => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    getCateList () {
      this.$api.tradesman.catelist({ size: 1000, status: 1 }).then((res) => {
        if (res.code == 200) {
          this.cateList = res.result.list;
        }
      });
    },
    getSorceList () {
      this.$api.tradesmansorce.list({ size: 10 }).then((res) => {
        if (res.code == 200) {
          this.sorceList = res.result.list;
        }
      });
    },
    getSkillList () {
      this.$api.tradesman
        .skilllist({ page: 1, size: 1000, status: 1 })
        .then((res) => {
          if (res.code == 200) {
            this.skillList = res.result.list;
          }
        });
    },
    getItemList () {
      this.$api.intangibleItem.list({ page: 1, size: 200 }).then((res) => {
        if (res.code == 200) {
          this.intangibleList = res.result.list;
        }
      });
    },
    changeDate (val) {
      this.formItem.starttime = val[0];
      this.formItem.endtime = val[1];
    },
    // 详情
    detail (index) {
      let that = this;
      this.tradesman = {};
      this.thumblist = [[], [], [], [], [], [], []];
      this.$refs["tradesmanValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.tradesman.id = index;
      this.$api.tradesman.detail({ id: index }).then((res) => {
        this.tradesman = res.result;
        this.tradesman.skill = this.tradesman.data.skill;
        this.tradesman.auth_company = this.tradesman.data.auth_company;
        this.tradesman.describe = this.tradesman.data.describe;
        this.tradesman.introduce = this.tradesman.data.introduce;
        this.tradesman.company_code = this.tradesman.data.company_code;
        this.tradesman.legal_person = this.tradesman.data.legal_person;
        this.tradesman.phone = this.tradesman.data.phone;
        this.tradesman.servicephone = this.tradesman.data.service_phone;
        this.tradesman.address = this.tradesman.data.address;
        // 图片处理
        this.pushThumbData([
          this.tradesman.data.legal_photo_facade,
          this.tradesman.data.legal_photo_back,
          this.tradesman.thumb,
          this.tradesman.data.image,
          this.tradesman.data.zizhi_picture,
          this.tradesman.data.company_photo,
          // this.tradesman.data.special_thumb
        ]);
        //处理富文本图片
        var good_content = this.tradesman.introduce;
        if (good_content) {
          var content = good_content.replace(
            /(<img [^>]*src=['"])([^'"]+)([^>]*)/g,
            function (match, $1, $2, $3) {
              if (/^http/.test($2)) {
                return $1 + $2 + $3;
              } else {
                return $1 + that.$publicData.ossUrl + $2 + $3;
              }
            }
          );
        } else {
          var content = "";
        }

        this.$refs["editContent"].message = content;
        // 省市区三个下拉框
        this.shiList = this.tradesman.shiList;
        console.log(this.shiList);
        this.quList = this.tradesman.quList;
        // console.log(this.tradesman.data.introduce);
      });
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished",
          });
        }
      }
    },
    getqrcodes (id) {
      this.$router.push("/agents/qrcodes/" + id);
    },
    showCreate () {
      this.tradesman = {
        id: 0,
        type: "0",
        is_invoice: "0",
        status: "1",
        auth_status: "0",
        sort: "0",
        is_pos: "0",
        register_status: this.register_status,
      };
      this.thumblist = [[], [], [], [], [], [], []];
      this.$refs["tradesmanValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
    },
    // 修改
    editgoods (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (
            this.register_status == 1 &&
            this.$refs[this.thumbRefList[0]].uploadList.length > 0
          ) {
            this.tradesman.legal_photo_facade = this.$refs[
              this.thumbRefList[0]
            ].uploadList[0].url;
          }
          if (
            this.register_status == 1 &&
            this.$refs[this.thumbRefList[1]].uploadList.length > 0
          ) {
            this.tradesman.legal_photo_back = this.$refs[
              this.thumbRefList[1]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[2]].uploadList.length > 0) {
            this.tradesman.thumb = this.$refs[
              this.thumbRefList[2]
            ].uploadList[0].url;
          }
          if (this.$refs[this.thumbRefList[3]].uploadList.length > 0) {
            this.tradesman.image = this.$refs[
              this.thumbRefList[3]
            ].uploadList[0].url;
          }
          if (
            this.register_status == 1 &&
            this.$refs[this.thumbRefList[4]].uploadList.length > 0
          ) {
            this.tradesman.zizhi_picture = this.$refs[
              this.thumbRefList[4]
            ].uploadList[0].url;
          }
          if (
            this.register_status == 1 &&
            this.$refs[this.thumbRefList[5]].uploadList.length > 0
          ) {
            this.tradesman.company_photo = this.$refs[
              this.thumbRefList[5]
            ].uploadList[0].url;
          }
          // if (
          //   this.register_status == 1 &&
          //   this.$refs[this.thumbRefList[6]].uploadList.length > 0
          // ) {
          //   this.tradesman.special_thumb = this.$refs[
          //     this.thumbRefList[6]
          //   ].uploadList[0].url
          // }
          this.tradesman.register_status = this.register_status;
          this.tradesman.introduce = this.$refs["editContent"].message;
          if (!this.tradesman.cate_id) {
            this.$Message.error("请选择匠人分类");
            return;
          }
          if (!this.tradesman.skill) {
            this.$Message.error("请选择技艺");
            return;
          }
          if (!this.tradesman.type) {
            this.$Message.error("请选择类型");
            return;
          }
          if (!this.tradesman.auth_company) {
            this.$Message.error("请输入匠人等级");
            return;
          }
          if (!this.tradesman.nickname) {
            this.$Message.error("请输入店铺名称");
            return;
          }
          if (!this.tradesman.thumb) {
            this.$Message.error("请上传匠人头像");
            return;
          }
          // if (!this.tradesman.legal_person) {
          //   this.$Message.error("请输入姓名");
          //   return
          // }
          if (this.tradesman.id > 0) {
            this.$api.tradesman.edit(this.tradesman).then((res) => {
              console.log(this.tradesman);
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.tradesman.create(this.tradesman).then((res) => {
              console.log(this.tradesman);
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function (uuid, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tradesman.remove({ uuid: uuid, id: id }).then((res) => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        },
      });
    },
    change () { },

    // 角色详情
    roleDetail (id) {
      this.showRoleStatus = !this.showRoleStatus;
      this.id = id;
      this.roleInfo.role_ids = [];
      this.$api.tradesman.rolelist({ id: id, type: 1 }).then((res) => {
        this.roleInfo.role_ids = res.result;
        this.role_ids = res.result;
        console.log(this.roleInfo.role_ids);
      });
    },
    // 查看商品列表
    goodlist (uuid) {
      this.$router.push("/tradgoods/list?from_uuid=" + uuid);
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then((res) => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then((res) => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then((res) => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    // 选中角色时
    roleCheck (data) {
      this.role_ids = data;
    },
    createRole () {
      this.$api.tradesman
        .roleedit({ role_ids: this.role_ids, id: this.id, type: 1 })
        .then((res) => {
          if (res.code == 200) {
            this.showEditInfoStatus = !this.showEditInfoStatus;
            this.$Message.success(res.msg);
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showRoleStatus = !this.showRoleStatus;
        });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var ps = {
        key: this.formItem.key,
        starttime: this.formItem.starttime,
        endtime: this.formItem.endtime,
        page: this.pages.page,
        size: this.pages.size,
        register_status: this.register_status,
        sorce: this.formItem.sorce,
        phone: this.formItem.phone,
      };
      this.dataloading = true;
      this.$api.tradesman.list(ps).then((res) => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    exportShouru () {
      if (
        this.formItem.key == null ||
        this.formItem.key == "" ||
        this.formItem.key == undefined
      ) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.exportLoading = true;

      this.$api.tradesman
        .exportShouru({
          key: this.formItem.key,
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            // window.location.href = res.result;
          }
          this.exportLoading = false;
        });
    },
    exportOrder () {
      if (
        this.formItem.key == null ||
        this.formItem.key == "" ||
        this.formItem.key == undefined
      ) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.exportLoading = true;
      this.$api.tradesman
        .exportOrder({ key: this.formItem.key })
        .then((res) => {
          if (res.code == 200) {
            // window.location.href = res.result;
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
    exportPay () {
      if (
        this.formItem.key == null ||
        this.formItem.key == "" ||
        this.formItem.key == undefined
      ) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.exportLoading = true;
      this.$api.tradesman.exportPay({ key: this.formItem.key }).then((res) => {
        if (res.code == 200) {
          // window.location.href = res.result;
          this.$Message.success(res.msg);
        }
        this.exportLoading = false;
      });
    },
    exportShouchu () {
      if (
        this.formItem.key == null ||
        this.formItem.key == "" ||
        this.formItem.key == undefined
      ) {
        this.$Message.error("请输入手机号");
        return;
      }
      this.exportLoading = true;
      this.$api.tradesman
        .exportTradesmanGoods({
          key: this.formItem.key,
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime,
        })
        .then((res) => {
          if (res.code == 200) {
            // window.location.href = res.result;
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
    exportTrad () {
      this.exportLoading = true;
      this.$api.tradesman
        .exportHavingOrderTrad({
          start_date: this.formItem.starttime, //   否   date    开始时间
          end_date: this.formItem.endtime,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
  },
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.ivu-select .ivu-select-item {
  text-align: center;
}
.ivu-select .ivu-select-item img {
  width: 100px;
  object-fit: contain;
}
.ivu-modal-body .ivu-radio-group .ivu-radio-wrapper img {
  width: 150px;
  object-fit: contain;
}
.sanRables {
  max-height: 400px;
  overflow-y: auto;
}
</style>
